import { defineMessages } from 'react-intl'

const translations = defineMessages({
  reOrder: {
    defaultMessage: 'Re-Order',
    id: 'msp.account.order_history.order_detail.action.re_order'
  },
  orderReOrderTitle: {
    defaultMessage: 'Re-Order',
    id: 'msp.account.order_history.order_detail.reorder.title'
  },
  orderReOrderDescription: {
    defaultMessage: 'Do you really want to re-order this order?',
    id: 'msp.account.order_history.order_detail.reorder.description'
  },
  orderReOrderConfirm: {
    defaultMessage: 'Yes, re-order',
    id: 'msp.account.order_history.order_detail.reorder.confirm'
  },
  orderReOrderCancel: {
    defaultMessage: 'No',
    id: 'msp.account.order_history.order_detail.reorder.cancel'
  }
})

export default translations
